'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var numberRange = require('./number-range.js');

const randomNumber = ({ min, max }) => {
    numberRange.assertNumberRange({ min, max });
    return Math.floor(Math.random() * (max - min) + min);
};

exports.randomNumber = randomNumber;
//# sourceMappingURL=random-number.js.map
